import * as THREE from "three";
import type { HelperLine } from "./types";

const PARALLEL_EPSILON = 1e-10;

/**
 * Intersection of two infinite lines in XZ. Returns null when they are parallel.
 * The result keeps the y of the first line's anchor point — the sketch plane is XZ.
 */
function intersectLines({ first, second }: { first: HelperLine; second: HelperLine }): THREE.Vector3 | null {
	const determinant = first.direction.x * second.direction.z - first.direction.z * second.direction.x;

	if (Math.abs(determinant) < PARALLEL_EPSILON) {
		return null;
	}

	const deltaX = second.point.x - first.point.x;
	const deltaZ = second.point.z - first.point.z;
	const distanceAlongFirst = (deltaX * second.direction.z - deltaZ * second.direction.x) / determinant;

	return new THREE.Vector3(first.point.x + distanceAlongFirst * first.direction.x, first.point.y, first.point.z + distanceAlongFirst * first.direction.z);
}

export { intersectLines };
